// export const themeLight = {
// 	text: '#161b1d',
// 	label: '#4D4D4D',
// 	disabled: '#B3B3B3',
// 	background: '#e9eff2',
// 	primary: '#3b647b',
// 	secondary: '#89b8d2',
// 	accent: '#3895c7',
// 	textShadow: 'rgba(0, 0, 0, 0.5)',
// 	imageShadow: 'rgba(88, 147, 184, 0.671)',
// };

// export const themeDark = {
// 	text: '#e2e7e9', // Light gray for text
// 	label: '#B0B0B0', // Medium gray for labels
// 	disabled: '#6D6D6D', // Dark gray for disabled elements
// 	background: '#0d1316', // Very dark gray for background
// 	primary: '#a2c1d2', // Slightly lighter than light mode primary for contrast
// 	secondary: '#2d5d76', // A bit lighter for better readability
// 	accent: '#3895c7', // Lighter blue for accents
// 	textShadow: 'rgba(255, 253, 253, 0.5)',
// 	imageShadow: 'rgba(58, 95, 117, 0.708)',
// };

export const themeLight = {
	text: '#000000 ',
	secondaryText: '#F5F5F5',
	label: '#4D4D4D',
	disabled: '#B3B3B3',
	background: '#FFFFFF',
	backgroundLowOpac: '#fffffff1',
	secondaryBackground: '#F5F5F5',
	primary: '#000000 ',
	secondary: '#666666',
	accent: '#2d5d76',
	textShadow: 'rgba(0, 0, 0, 0.3)',
	imageShadow: 'rgba(0, 0, 0, 0.5)',
	isLightMode: true,
	navBorder: 'rgba(0,0,0,0.2)',
};

export const themeDark = {
	text: '#FFFFFF', // Light gray for text
	secondaryText: '#000000',
	label: '#B0B0B0', // Medium gray for labels
	disabled: '#6D6D6D', // Dark gray for disabled elements
	background: '#000000', // Very dark gray for background
	backgroundLowOpac: '#000000f1',
	secondaryBackground: '#111111',
	primary: '#FFFFFF', // Slightly lighter than light mode primary for contrast
	secondary: '#666666', // A bit lighter for better readability
	accent: '#2d5d76', // Lighter blue for accents
	textShadow: 'rgba(255, 253, 253, 0.3)',
	imageShadow: 'rgba(255,255,255,0.6)',
	isLightMode: false,
	navBorder: 'rgba(255,255,255,0.2)',
};
